export const RESET_DATA_STATE = 'app/RESET_DATA_STATE'
export interface ResetDataStateAction {
  type: typeof RESET_DATA_STATE
}
export const createResetDataState = (): ResetDataStateAction => ({
  type: RESET_DATA_STATE,
})
